import {
    OU_WIZARD_ACCESS,
    REGIME_ASSETS_ACCESS,
    REVIEW_CHANGES_ACCESS,
    REVIEW_SFG20_CHANGES_ACCESS,
} from "./tiered-access-demands.mjs"
import { OPTIMISER_DEMANDS } from "modules/licensing/hubspot/optimiser-product-demands.mjs"

const availableProducts = {}

export function addProduct(
    sku,
    {
        description = "",
        regimes = 0,
        quantity = 0,
        createLicences = 0,
        collaborateLicences = 0,
        viewLicences = 0,
        demands = [],
        hasQuantity = false,
    }
) {
    availableProducts[sku] = {
        sku,
        description,
        regimes,
        quantity,
        createLicences,
        collaborateLicences,
        viewLicences,
        demands,
        hasQuantity,
    }
    return demands
}

const ADVANCED_REGIMES_DEMANDS_ADVANCED = [
    "feature-advanced-regime-tabs",
    "feature-asset-mapping-tailored",
    "feature-asset-mapping-overview",
]

const ADVANCED_REGIMES_DEMANDS_PRO = [
    OU_WIZARD_ACCESS, //Unspecified frequencies Tab
    "feature-asset-mapping-schedule-library-updates",
    REVIEW_SFG20_CHANGES_ACCESS, //Variation from Library
    "feature-asset-mapping-variation-from-library",
    REVIEW_CHANGES_ACCESS, //Variation from Previous
]

addProduct("FIQT3", {
    regimes: 100,
    quantity: 1,
    demands: [
        "scheduleEditor",
        "publishSchedule",
        "create-conformity",
        "advancedTailoring",
        "feature-downloadSchedulePdf",
        "feature-download-tasks",
        "feature-ai-schedules",
        "feature-regimePermissions",
        "api-access",
        REGIME_ASSETS_ACCESS,
        "feature-qrCodes-pdf",
        "feature-identity-provider",
        ...ADVANCED_REGIMES_DEMANDS_ADVANCED,
        ...ADVANCED_REGIMES_DEMANDS_PRO,
        "feature-regime-auditing",
        "feature-tailored-schedule-auditing",
        "feature-regime-draft-locking",
    ],
})

addProduct("FIQT2", {
    regimes: 5,
    quantity: 1,
    demands: [
        "create-conformity",
        "advancedTailoring",
        "feature-downloadSchedulePdf",
        "feature-download-tasks",
        "feature-regimePermissions",
        "api-access",
        REGIME_ASSETS_ACCESS,
        "feature-qrCodes-pdf",
        ...ADVANCED_REGIMES_DEMANDS_ADVANCED,
        "feature-regime-auditing",
        "feature-tailored-schedule-auditing",
        "feature-regime-draft-locking",
    ],
})
addProduct("FIQT1", {
    regimes: 1,
    quantity: 1,
    demands: [
        "create-conformity",
        "feature-downloadSchedulePdf",
        "feature-regimePermissions",
        "feature-qrCodes-pdf",
        "feature-regime-auditing",
        "feature-tailored-schedule-auditing",
        "feature-regime-draft-locking",
    ],
})
addProduct("FIQCREATET3", { createLicences: 1, hasQuantity: true })

addProduct("FIQCREATET2", { createLicences: 1, hasQuantity: true })
addProduct("FIQCREATET1", { createLicences: 1, hasQuantity: true })
addProduct("FIQCOLLABORATE", { collaborateLicences: 1, viewLicences: 1, hasQuantity: true })
addProduct("FIQACCESSEQUILIFT", { demands: ["schedule_type_22"] })

addProduct("FIQCATERING", { demands: ["schedule_type_21"] })
addProduct("FIQFABRIC", { demands: ["schedule_type_27"] })
addProduct("FIQHTMALIGNED", { demands: ["schedule_type_25"] })
addProduct("FIQLABEQUIP", { demands: ["schedule_type_39"] })
addProduct("FIQMANAGEMENT", { demands: ["schedule_type_35"] })
addProduct("FIQMHE", { demands: ["schedule_type_26"] })
addProduct("FIQOPERATIONAL", { demands: ["schedule_type_24"] })
addProduct("FIQRESIDENTIAL", { demands: ["residential_sets"] })
addProduct("FIQS-RESCARHOMES", { demands: ["schedule_type_37"] })
addProduct("FIQS-RESPROP", { demands: ["schedule_type_38"] })
addProduct("FIQS-RESSET", { demands: ["schedule_type_38"] })
addProduct("FIQSECURITY", { demands: ["schedule_type_28"] })
addProduct("FIQMOTHBALLING", { demands: ["schedule_type_34"] })
addProduct("FIQWORKSHOPEQUIPT", { demands: ["schedule_type_23"] })
addProduct("FIQTECHSUPPORT", { demands: ["FIQTECHSUPPORT"] })
addProduct("FIQBOOKLET", { demands: ["feature-download-booklet"] })
addProduct("FIQXML", { demands: ["feature-download-xml"] })
addProduct("FIQSHARELINKDIST", {
    demands: ["feature-shareLinkDistribution", "feature-downloadSchedulePdf", "feature-qrCodes-pdf"],
})
addProduct("FIQ5ADDREGIMES", { description: "Additional 5 regimes", regimes: 5, hasQuantity: true })

export const FIQASSETMAPPING = addProduct("FIQASSETMAPPING", {
    description: "Enable Asset Mapping for Clients",
    demands: [
        "feature-assets",
        "feature-navigator",
        "feature-asset-mapping-variation-from-library",
        "feature-asset-mapping-schedule-library-updates",
        "feature-asset-mapping-overview",
        "feature-asset-mapping-tailored",
        "feature-advanced-regime-tabs",
        OU_WIZARD_ACCESS,
        REGIME_ASSETS_ACCESS,
        REVIEW_CHANGES_ACCESS,
        REVIEW_SFG20_CHANGES_ACCESS,
    ],
})

export const FIQMOBILISER = addProduct("FIQMOBILISER", {
    description: "Enables AI mapping using Mobiliser",
    demands: [
        "feature-mobiliser",
        "feature-ai-mapping-feedback",
        "feature-assets",
        "feature-navigator",
        "feature-asset-mapping-variation-from-library",
        "feature-asset-mapping-schedule-library-updates",
        "feature-asset-mapping-overview",
        "feature-asset-mapping-tailored",
        "feature-advanced-regime-tabs",
        OU_WIZARD_ACCESS,
        REGIME_ASSETS_ACCESS,
        REVIEW_CHANGES_ACCESS,
        REVIEW_SFG20_CHANGES_ACCESS,
    ],
})

addProduct("AUTHORING", {
    description: "Enable Tech Authoring system on /authoring",
    demands: ["feature-authoring"],
})

// SKU must match dh_subscription_product_sku on the HubSpot "SFG20 Optimiser" product exactly.
// Demands are shared with the FIQT3 prerequisite gate (optimiser-product-demands.mjs):
// this product is sold as Professional-tier-only, so without FIQT3 these demands are stripped.
addProduct("FIQOPTIMISER", {
    description: "SFG20 Optimiser - scenario modelling (Professional tier only)",
    demands: OPTIMISER_DEMANDS,
})

export function getAvailableProducts() {
    return availableProducts
}

export function getAvailableProductsArray() {
    return Object.values(availableProducts)
}

export function getFeatureDemandsForProducts() {
    return new Set(
        Object.values(availableProducts)
            .filter((p) => p.demands.some((d) => d.startsWith("feature-")))
            .flatMap((product) => product.demands.filter((demand) => demand.startsWith("feature-")))
    )
}
